/**
 * Enable CSS transition effect after page loading
 */

jQuery(document).ready(function () {
    jQuery('body').removeClass('stop-transition');
});
